import { PricePlanService } from './../../priceplanService';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from 'src/app/services/api.service';
import { SubscriptionFeatures } from 'src/app/services/userModel';
import { UtilService } from 'src/app/services/util.service';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-plan-feature',
  standalone: true,
  imports: [CommonModule, NgbAccordionModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './plan-feature.component.html',
  styleUrls: ['./plan-feature.component.scss']
})
export class PlanFeatureComponent implements OnInit {

  featurelists: SubscriptionFeatures;
  constructor(private API: ApiService, private util: UtilService, private pricePlanService: PricePlanService) { }
  ngOnInit() {
    this.plansandfeatureslist();
  }

  async plansandfeatureslist() {
    let planResponse = await this.pricePlanService.getPlan_Features();
    const { data : {planWiseSubscriptionFeatures : planFeauture} } = planResponse;
    this.featurelists = planFeauture;
    console.log("plan" , this.featurelists);

    this.util.stopLoader();
  }



  returnZero() {
    return 0;
  }

}
